export default __webpack_public_path__ + "static/media/rave.b35a4696.jpg";